import { gql } from "@apollo/client";

const SendOTPMutation = gql`
  mutation sendOtp(
    $countryCode: String!
    $phoneNumber: String!
    $ref: String
    $messagingService: String!
    $cid: String
    $cpid: String
    $platform: String
    $urlCode: String
    $channelSlug: String!
  ) {
    sendOtp(
      countryCode: $countryCode
      phoneNumber: $phoneNumber
      ref: $ref
      messagingService: $messagingService
      cid: $cid
      cpid: $cpid
      platform: $platform
      urlCode: $urlCode
      channelSlug: $channelSlug
    ) {
      message
      errors {
        message
        field
        code
      }
    }
  }
`;

const LoginMutation = gql`
  mutation login($countryCode: String!, $phoneNumber: String!, $otp: String!) {
    login(countryCode: $countryCode, phoneNumber: $phoneNumber, otp: $otp) {
      token
      refreshToken
      user {
        id
        email
        firstName
        lastName
        metadata
      }
      errors {
        message
        field
        code
      }
    }
  }
`;

const ValidLoginMutation = gql`
  mutation validLogin(
    $countryCode: String!
    $phoneNumber: String!
    $channelSlug: String!
    $cid: String
    $cpid: String
  ) {
    validLogin(
      countryCode: $countryCode
      phoneNumber: $phoneNumber
      channelSlug: $channelSlug
      cid: $cid
      cpid: $cpid
    ) {
      message
      errors {
        message
        field
      }
    }
  }
`;

export { SendOTPMutation, LoginMutation, ValidLoginMutation };
